import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";

const dimensionsOptions = [
  { label: "X", property: "left" },
  { label: "Y", property: "top" },
  { label: "Width", property: "width" },
  { label: "Height", property: "height" },
];

type Props = {
  width: number;
  height: number;
  left: number;
  top: number;
  isEditingRef: React.MutableRefObject<boolean>;
  handleInputChange: (property: string, value: string) => void;
};

const Dimensions = ({
  width,
  height,
  left,
  top,
  isEditingRef,
  handleInputChange,
}: Props) => (
  <section className="flex flex-col border-b border-borderColor px-2 py-5">
    <div className="grid grid-cols-2 gap-1 gap-y-2">
      {dimensionsOptions.map((item) => (
        <div key={item.label} className="w-full">
          <h3 className="text-[10px] uppercase px-1 mb-2">{item.label}</h3>

          <div
            key={item.label}
            className="flex flex-1 items-center gap-2 rounded-sm"
          >
            <Input
              type="number"
              id={item.property}
              placeholder="100"
              value={
                item.property === "width"
                  ? width
                  : item.property === "height"
                  ? height
                  : item.property === "left"
                  ? left
                  : top
              }
              className="input-ring bg-transparent text-white placeholder"
              // min={0}
              onChange={(e) => {
                handleInputChange(item.property, e.target.value);
              }}
              onBlur={(e) => {
                isEditingRef.current = false;
              }}
            />
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default Dimensions;
